import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { BlocksIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const rootedAppDefinition: SmartSignalDefinition<{ root_apps?: IdEventV4['root_apps'] }> = {
  key: 'rooted-app',
  label: 'Rooted app',
  extract: (e) => ({ root_apps: e.root_apps }),
  icon(e) {
    const p = this.extract(e)?.root_apps
    return (
      <BlocksIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.root_apps
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"root_apps":',
  documentationHash: '#rooted-device-detection',
  urlParamKey: IdentificationUrlKeys.RootedDevice,
}
